/**
 * "Cancelled By" on the claim drawer: the email of the team member who
 * pressed Cancel, or a plain label when a processor or script did it (Dec, 9 Oct 2026).
 *
 * The cancel flow stores the actor in cancellationUpdatedBy (a staff email
 * for screen cancels) and the route in cancellationSource. Internal
 * source codes are never shown (house UI rule): unknown ones read "Automatic process".
 */
const PROCESSOR_LABELS: Record<string, string> = {
  'email-llm': 'Auto-canceller (client email)',
  email: 'Auto-canceller (client email)',
  'bulk-email-process': 'Auto-canceller (client email)',
  'loc-auto-cancel': 'LOC auto-cancel',
  'claims-gate-auto': 'Claimsgate (automatic)',
  auto: 'Automatic',
  'data-cleanup': 'Data clean-up',
  'admin-ui': 'Staff (name not recorded)',
  'worldpay_virtual_terminal': 'Card payment (phone)',
  'credit-check-import-auto': 'Credit check import',
  'automated-associated-cancellation': 'Automatic (linked claim)',
  'caf-workflow': 'Automatic workflow',
  free: 'Cancelled within 14 days',
  manual_payment: 'Fee paid by bank transfer',
  paid: 'Fee paid',
  paid_webhook: 'Fee paid',
};

export function cancelledByLabel(
  source?: string | null,
  updatedBy?: string | null,
): { label: string } {
  const src = (source || '').trim();
  const by = (updatedBy || '').trim();

  if (by.includes('@')) return { label: by };
  if (src && PROCESSOR_LABELS[src]) return { label: PROCESSOR_LABELS[src] };
  if (/bulk|script/i.test(`${src} ${by}`)) return { label: 'Bulk update' };
  if (src || by) return { label: 'Automatic process' };
  return { label: 'N/A' };
}
